import styled from 'styled-components';

export default styled.p`
  font-family: 'Maison Neue';
  font-size: 14px;
  color: #6c7484;
  margin: 0;
`